import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Box, Button, CircularProgress, Typography } from '@material-ui/core';

const useStyles = makeStyles({
  loadMore: {
    marginBottom: '20px'
  }
});

const LoadMoreButton = ({
  loading,
  canLoadMore,
  loadMore,
  loadMoreTranslation,
  noMoreToLoadTranslation
}) => {
  const classes = useStyles();

  return (
    <Box display='flex' justifyContent='center'>
      {loading ?
        <CircularProgress /> :
        canLoadMore ?
          <Button
            onClick={ loadMore }
            variant='contained'
            color="secondary"
            className={ classes.loadMore }
          >
            { loadMoreTranslation }
          </Button>  :
          <Typography
            variant="h6"
            component="h3"
            className={ classes.loadMore }
          >
            { noMoreToLoadTranslation }
          </Typography>
      }
    </Box>
  );
};

export default LoadMoreButton;
